import { get } from 'lodash/fp';
import { RequestError } from '@mews-framework/data-access';

export default (error: RequestError | Error) => get(['data', 'errors'], error);
